<template>
  <div class="login">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>物流后台管理系统</span>
      </div>
      <el-form label-width="50px">
        <el-form-item>
          账号：<el-input type="text" v-model="username"></el-input>
          密码：<el-input type="password" v-model="password" class="pwd"></el-input>
          <el-button type="primary" @click="handlelogin()">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: '',//admin
      password: ''//root
    }
  },
  mounted() {
    // console.log(document.cookie);
    // if (
    //   document.cookie ===
    //   "_legacy_auth0.Aaj2RxJGoEI7pZziQ0rEUgtFAhM1nzEX.is.authenticated=true; auth0.Aaj2RxJGoEI7pZziQ0rEUgtFAhM1nzEX.is.authenticated=true"
    // ) {
    //   this.$router.push({ path: "/home" });
    // }
  },
  methods: {
    handlelogin() {
      // this.$auth.loginWithRedirect();
      // if((this.username == 'CKWJ' && this.password == 'CKWJ123') || (this.username == 'HB' && this.password == 'HB12345') || (this.username == 'ST' && this.password == 'st12345') || (this.username == 'WSY' && this.password == 'wsyqwert')){
      if(this.username == 'CKWJ' && this.password == '5Sfsh0@H@JM16RH+75jxmulkd82y'){
        // this.$router.push({ path: "/home/productlist", query: { un: this.username} });
        this.$router.push({ path: "/home/productlist"});
        // window.localStorage.setItem('un',this.username);
      }else if(this.username == '' || this.password == ''){
        this.$message({
          message: '账号或密码不能为空',
          type: 'warning'
        });
      }else if(this.username != 'CKWJ' || this.password != '5Sfsh0@H@JM16RH+75jxmulkd82y'){
        this.$message({
          message: '账号或密码输入错误',
          type: 'error'
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pwd{
  margin-bottom: 20px;
}
.login {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #409eff;
  .box-card {
    width: 450px;
    margin: 200px auto;
    span {
      font-size: 30px;
      font-weight: bolder;
    }
    .el-button {
      width: 100%;
    }
  }
}
.clearfix {
  padding-left: 30px;
  text-align: center;
}
.el-form,
.clearfix {
  margin-right: 30px;
}
</style>